(function() {
  var bar = document.querySelector('[data-sticky-bar]');
  if (!bar) return;

  var options = bar.querySelectorAll('.sticky-bar__option');
  var cta = bar.querySelector('[data-cta-link]');
  var priceEl = bar.querySelector('[data-price-display]');
  var perunitEl = bar.querySelector('[data-perunit-display]');
  var close = bar.querySelector('.sticky-bar__close');
  var currentPlan = '1';

  /* ---- Plan toggle ---- */
  options.forEach(function(opt) {
    opt.addEventListener('click', function() {
      var id = this.dataset.plan;
      if (id === currentPlan) return;
      currentPlan = id;

      options.forEach(function(o) {
        var active = o.dataset.plan === id;
        o.classList.toggle('sticky-bar__option--active', active);
        o.setAttribute('aria-checked', active);
      });

      /* Update price */
      if (priceEl && cta.dataset['price' + id]) {
        priceEl.textContent = cta.dataset['price' + id];
      }

      /* Update per-unit */
      if (perunitEl && cta.dataset['perunit' + id]) {
        perunitEl.textContent = cta.dataset['perunit' + id];
      }

      /* Update CTA link */
      if (cta.dataset['link' + id]) {
        cta.setAttribute('href', cta.dataset['link' + id]);
      }
    });
  });

  /* ---- Close with remember ---- */
  close.addEventListener('click', function() {
    bar.classList.add('sticky-bar--hidden');
    try { sessionStorage.setItem('sticky-bar-closed', '1'); } catch(e) {}
  });

  /* Respect previous close */
  try {
    if (sessionStorage.getItem('sticky-bar-closed') === '1') {
      bar.classList.add('sticky-bar--hidden');
    }
  } catch(e) {}

  /* ---- AJAX add-to-cart ---- */
  cta.addEventListener('click', function(e) {
    var href = this.getAttribute('href');
    if (!href || !href.includes('/cart/add')) return;
    e.preventDefault();

    var el = this;
    var textEl = el.querySelector('[data-cta-text]');
    var original = textEl.textContent;
    textEl.textContent = 'Agregando...';
    el.classList.add('sticky-bar__cta--loading');

    var url = new URL(href, window.location.origin);
    var id = url.searchParams.get('id');
    var qty = url.searchParams.get('quantity') || 1;
    var sp = url.searchParams.get('selling_plan');

    if (!id) { window.location.href = href; return; }

    var body = { id: +id, quantity: +qty };
    if (sp) body.selling_plan = +sp;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function(res) {
      if (!res.ok) throw new Error('add failed');
      textEl.textContent = 'Agregado \u2713';
      el.classList.remove('sticky-bar__cta--loading');
      el.classList.add('sticky-bar__cta--success');
      setTimeout(function() { window.location.href = '/cart'; }, 800);
    }).catch(function() {
      el.classList.remove('sticky-bar__cta--loading');
      textEl.textContent = original;
      window.location.href = href;
    });
  });

  /* ---- Show bar after scroll ---- */
  var shown = false;
  var isMobile = window.innerWidth < 768;
  var threshold = isMobile ? 0.15 : 0.6;
  function checkScroll() {
    if (shown) return;
    if (window.scrollY > window.innerHeight * threshold) {
      bar.classList.add('sticky-bar--visible');
      shown = true;
      window.removeEventListener('scroll', checkScroll);
    }
  }
  window.addEventListener('scroll', checkScroll, { passive: true });
  checkScroll();
})();
